<template>
  <keep-alive>
    <div class="container flex flex-col mx-auto">
      <LivingClassVue></LivingClassVue>
    </div>
  </keep-alive>
</template>

<script lang="ts" setup>
useHead({
  title: '在线课程',
})
</script>

<style></style>
